export default __webpack_public_path__ + "static/media/Links.13ca73ea.jpg";